import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { TimeService } from '../time.service';
import { ValidationService } from '../validation.service';

@Component({
  selector: 'app-acknowlegde',
  templateUrl: './acknowlegde.component.html',
  styleUrls: ['./acknowlegde.component.scss']
})
export class AcknowlegdeComponent implements OnInit {
till: any = new Date();

  type = '';
  id = '';
  ackDialogRef;
  regNo = '';
  ackType = '';
 @ViewChild('ackDialog', { static: true }) ackDialog: TemplateRef<any>;

  constructor(private http: HttpService, private router: Router, private snackbar: SnackbarService, private timeService: TimeService, private dialog: MatDialog, private valid: ValidationService, private route: ActivatedRoute,) { }

  ngOnInit() {
this.route.paramMap.subscribe(params => {
      this.id = params.get("id");
      this.type = params.get("type");
  if (this.id && this.type) {
    if (this.type === 'halt') this.ackType = 'Halt Alert';
    this.http.get('v1/vehicle?id=' + this.id, 3).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.regNo = response.data.REG_number;
        this.openAckDialog();
      }
    });
      }
     });
  }

  openAckDialog() {
    this.ackDialogRef = this.dialog.open(this.ackDialog);
  }
  closeDialog() {
    this.ackDialogRef.close();
    this.router.navigateByUrl('/overview');
  }
  setAckTime(hours) {
    this.till = new Date();
    this.till.setHours(this.till.getHours() + hours);
  }
  acknowledge() {
    const dataToSend: any = {
      stop_halt_alerts_till: this.till,
    };
    if (this.type === 'halt') dataToSend.attachedDriver = this.id;
    this.http.put('v1/settings/ack_halt_alert', dataToSend).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.snackbar.openSnackBar('Acknowledged halt alert', '',);
        this.closeDialog();
        
      }
    },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

}
